const FETCH_ALL_STOCK_MANAGEMENT_REGISTERS = "FETCH_ALL_STOCK_MANAGEMENT_REGISTERS";
const FETCH_ALL_STOCK_MANAGEMENT_REGISTERS_SUCCESS = "FETCH_ALL_STOCK_MANAGEMENT_REGISTERS_SUCCESS";
const FETCH_ALL_STOCK_MANAGEMENT_REGISTERS_ERROR = "FETCH_ALL_STOCK_MANAGEMENT_REGISTERS_ERROR";
const FETCH_STOCK_MANAGEMENT_REGISTER = "FETCH_STOCK_MANAGEMENT_REGISTER";
const FETCH_STOCK_MANAGEMENT_REGISTER_SUCCESS = "FETCH_STOCK_MANAGEMENT_REGISTER_SUCCESS";
const FETCH_STOCK_MANAGEMENT_REGISTER_ERROR = "FETCH_STOCK_MANAGEMENT_REGISTER_ERROR";
const CREATE_STOCK_MANAGEMENT_REGISTER = "CREATE_STOCK_MANAGEMENT_REGISTER";
const CREATE_STOCK_MANAGEMENT_REGISTER_SUCCESS = "CREATE_STOCK_MANAGEMENT_REGISTER_SUCCESS";
const CREATE_STOCK_MANAGEMENT_REGISTER_ERROR = "CREATE_STOCK_MANAGEMENT_REGISTER_ERROR";
const UPDATE_STOCK_MANAGEMENT_REGISTER = "UPDATE_STOCK_MANAGEMENT_REGISTER";
const UPDATE_STOCK_MANAGEMENT_REGISTER_SUCCESS = "UPDATE_STOCK_MANAGEMENT_REGISTER_SUCCESS";
const UPDATE_STOCK_MANAGEMENT_REGISTER_ERROR = "UPDATE_STOCK_MANAGEMENT_REGISTER_ERROR";
const DELETE_LAB_STOCK_DOC_ATTACH = "DELETE_LAB_STOCK_DOC_ATTACH";
const DELETE_LAB_STOCK_DOC_ATTACH_SUCCESS = "DELETE_LAB_STOCK_DOC_ATTACH_SUCCESS";
const DELETE_LAB_STOCK_DOC_ATTACH_ERROR = "DELETE_LAB_STOCK_DOC_ATTACH_ERROR";
const UPDATE_LAB_STOCK_ISADD_ISUPDATE = "UPDATE_LAB_STOCK_ISADD_ISUPDATE";
const ADD_LAB_STOCK_DOC_ATTACH = "ADD_LAB_STOCK_DOC_ATTACH";
const FETCH_ALL_STOCK_TAKES = "FETCH_ALL_STOCK_TAKES";
const FETCH_ALL_STOCK_TAKES_SUCCESS = "FETCH_ALL_STOCK_TAKES_SUCCESS";
const FETCH_ALL_STOCK_TAKES_ERROR = "FETCH_ALL_STOCK_TAKES_ERROR";
const CREATE_STOCK_TAKE = "CREATE_STOCK_TAKE";
const CREATE_STOCK_TAKE_SUCCESS = "CREATE_STOCK_TAKE_SUCCESS";
const CREATE_STOCK_TAKE_ERROR = "CREATE_STOCK_TAKE_ERROR";
const UPDATE_STOCK_TAKE = "UPDATE_STOCK_TAKE";
const UPDATE_STOCK_TAKE_SUCCESS = "UPDATE_STOCK_TAKE_SUCCESS";
const UPDATE_STOCK_TAKE_ERROR = "UPDATE_STOCK_TAKE_ERROR";
const DELETE_STOCK_TAKE = "DELETE_STOCK_TAKE";
const DELETE_STOCK_TAKE_SUCCESS = "DELETE_STOCK_TAKE_SUCCESS";
const DELETE_STOCK_TAKE_ERROR = "DELETE_STOCK_TAKE_ERROR";
const DELETE_STOCK_MANAGEMENT_REGISTER = "DELETE_STOCK_MANAGEMENT_REGISTER";
const DELETE_STOCK_MANAGEMENT_REGISTER_SUCCESS = "DELETE_STOCK_MANAGEMENT_REGISTER_SUCCESS";
const DELETE_STOCK_MANAGEMENT_REGISTER_ERROR = "DELETE_STOCK_MANAGEMENT_REGISTER_ERROR";
const SET_STOCK_MANAGEMENT_FILTERS = "SET_STOCK_MANAGEMENT_FILTERS";
const SET_STOCK_MANAGEMENT_PAGINATION = "SET_STOCK_MANAGEMENT_PAGINATION";
const CLEAR_STOCK_MANAGEMENT_REGISTER = "CLEAR_STOCK_MANAGEMENT_REGISTER";
const CLEAR_STOCK_TAKES = "CLEAR_STOCK_TAKES";
const CLEAR_STOCK_TAKE_ERROR = "CLEAR_STOCK_TAKE_ERROR";
const FETCH_OMNI_CURRENT_STOCK = "FETCH_OMNI_CURRENT_STOCK";
const FETCH_OMNI_CURRENT_STOCK_SUCCESS = "FETCH_OMNI_CURRENT_STOCK_SUCCESS";
const FETCH_OMNI_CURRENT_STOCK_ERROR = "FETCH_OMNI_CURRENT_STOCK_ERROR";
const FETCH_OMNI_SNAPSHOTS_SUCCESS = "FETCH_OMNI_SNAPSHOTS_SUCCESS";
const GENERATE_VARIANCE_REPORT = "GENERATE_VARIANCE_REPORT";
const GENERATE_VARIANCE_REPORT_SUCCESS = "GENERATE_VARIANCE_REPORT_SUCCESS";
const GENERATE_VARIANCE_REPORT_ERROR = "GENERATE_VARIANCE_REPORT_ERROR";
const FETCH_VARIANCE_REPORTS = "FETCH_VARIANCE_REPORTS";
const FETCH_VARIANCE_REPORTS_SUCCESS = "FETCH_VARIANCE_REPORTS_SUCCESS";
const FETCH_VARIANCE_REPORTS_ERROR = "FETCH_VARIANCE_REPORTS_ERROR";
const FETCH_ALL_VARIANCE_REPORTS = "FETCH_ALL_VARIANCE_REPORTS";
const FETCH_ALL_VARIANCE_REPORTS_SUCCESS = "FETCH_ALL_VARIANCE_REPORTS_SUCCESS";
const FETCH_ALL_VARIANCE_REPORTS_ERROR = "FETCH_ALL_VARIANCE_REPORTS_ERROR";
const FETCH_ONE_VARIANCE_REPORT = "FETCH_ONE_VARIANCE_REPORT";
const FETCH_ONE_VARIANCE_REPORT_SUCCESS = "FETCH_ONE_VARIANCE_REPORT_SUCCESS";
const FETCH_ONE_VARIANCE_REPORT_ERROR = "FETCH_ONE_VARIANCE_REPORT_ERROR";
const UPDATE_VARIANCE_REPORT = "UPDATE_VARIANCE_REPORT";
const UPDATE_VARIANCE_REPORT_SUCCESS = "UPDATE_VARIANCE_REPORT_SUCCESS";
const UPDATE_VARIANCE_REPORT_ERROR = "UPDATE_VARIANCE_REPORT_ERROR";
const ADD_VARIANCE_COMMENT = "ADD_VARIANCE_COMMENT";
const ADD_VARIANCE_COMMENT_SUCCESS = "ADD_VARIANCE_COMMENT_SUCCESS";
const ADD_VARIANCE_COMMENT_ERROR = "ADD_VARIANCE_COMMENT_ERROR";
const DELETE_VARIANCE_ATTACHMENT = "DELETE_VARIANCE_ATTACHMENT";
const DELETE_VARIANCE_ATTACHMENT_SUCCESS = "DELETE_VARIANCE_ATTACHMENT_SUCCESS";
const DELETE_VARIANCE_ATTACHMENT_ERROR = "DELETE_VARIANCE_ATTACHMENT_ERROR";
const FETCH_VARIANCE_HISTORY = "FETCH_VARIANCE_HISTORY";
const FETCH_VARIANCE_HISTORY_SUCCESS = "FETCH_VARIANCE_HISTORY_SUCCESS";
const FETCH_VARIANCE_HISTORY_ERROR = "FETCH_VARIANCE_HISTORY_ERROR";
const SYNC_LAB_STOCK = "SYNC_LAB_STOCK";
const SYNC_LAB_STOCK_SUCCESS = "SYNC_LAB_STOCK_SUCCESS";
const SYNC_LAB_STOCK_ERROR = "SYNC_LAB_STOCK_ERROR";
const FETCH_LAST_SYNC_TIME = "FETCH_LAST_SYNC_TIME";
const FETCH_LAST_SYNC_TIME_SUCCESS = "FETCH_LAST_SYNC_TIME_SUCCESS";
const FETCH_LAST_SYNC_TIME_ERROR = "FETCH_LAST_SYNC_TIME_ERROR";

export {
  FETCH_ALL_STOCK_MANAGEMENT_REGISTERS,
  FETCH_ALL_STOCK_MANAGEMENT_REGISTERS_SUCCESS,
  FETCH_ALL_STOCK_MANAGEMENT_REGISTERS_ERROR,
  FETCH_STOCK_MANAGEMENT_REGISTER,
  FETCH_STOCK_MANAGEMENT_REGISTER_SUCCESS,
  FETCH_STOCK_MANAGEMENT_REGISTER_ERROR,
  CREATE_STOCK_MANAGEMENT_REGISTER,
  CREATE_STOCK_MANAGEMENT_REGISTER_SUCCESS,
  CREATE_STOCK_MANAGEMENT_REGISTER_ERROR,
  UPDATE_STOCK_MANAGEMENT_REGISTER,
  UPDATE_STOCK_MANAGEMENT_REGISTER_SUCCESS,
  UPDATE_STOCK_MANAGEMENT_REGISTER_ERROR,
  ADD_LAB_STOCK_DOC_ATTACH,
  DELETE_LAB_STOCK_DOC_ATTACH,
  DELETE_LAB_STOCK_DOC_ATTACH_SUCCESS,
  DELETE_LAB_STOCK_DOC_ATTACH_ERROR,
  UPDATE_LAB_STOCK_ISADD_ISUPDATE,
  FETCH_ALL_STOCK_TAKES,
  FETCH_ALL_STOCK_TAKES_SUCCESS,
  FETCH_ALL_STOCK_TAKES_ERROR,
  CREATE_STOCK_TAKE,
  CREATE_STOCK_TAKE_SUCCESS,
  CREATE_STOCK_TAKE_ERROR,
  UPDATE_STOCK_TAKE,
  UPDATE_STOCK_TAKE_SUCCESS,
  UPDATE_STOCK_TAKE_ERROR,
  DELETE_STOCK_TAKE,
  DELETE_STOCK_TAKE_SUCCESS,
  DELETE_STOCK_TAKE_ERROR,
  DELETE_STOCK_MANAGEMENT_REGISTER,
  DELETE_STOCK_MANAGEMENT_REGISTER_SUCCESS,
  DELETE_STOCK_MANAGEMENT_REGISTER_ERROR,
  SET_STOCK_MANAGEMENT_FILTERS,
  SET_STOCK_MANAGEMENT_PAGINATION,
  CLEAR_STOCK_MANAGEMENT_REGISTER,
  CLEAR_STOCK_TAKES,
  CLEAR_STOCK_TAKE_ERROR,
  FETCH_OMNI_CURRENT_STOCK,
  FETCH_OMNI_CURRENT_STOCK_SUCCESS,
  FETCH_OMNI_CURRENT_STOCK_ERROR,
  FETCH_OMNI_SNAPSHOTS_SUCCESS,
  GENERATE_VARIANCE_REPORT,
  GENERATE_VARIANCE_REPORT_SUCCESS,
  GENERATE_VARIANCE_REPORT_ERROR,
  FETCH_VARIANCE_REPORTS,
  FETCH_VARIANCE_REPORTS_SUCCESS,
  FETCH_VARIANCE_REPORTS_ERROR,
  FETCH_ALL_VARIANCE_REPORTS,
  FETCH_ALL_VARIANCE_REPORTS_SUCCESS,
  FETCH_ALL_VARIANCE_REPORTS_ERROR,
  FETCH_ONE_VARIANCE_REPORT,
  FETCH_ONE_VARIANCE_REPORT_SUCCESS,
  FETCH_ONE_VARIANCE_REPORT_ERROR,
  UPDATE_VARIANCE_REPORT,
  UPDATE_VARIANCE_REPORT_SUCCESS,
  UPDATE_VARIANCE_REPORT_ERROR,
  ADD_VARIANCE_COMMENT,
  ADD_VARIANCE_COMMENT_SUCCESS,
  ADD_VARIANCE_COMMENT_ERROR,
  DELETE_VARIANCE_ATTACHMENT,
  DELETE_VARIANCE_ATTACHMENT_SUCCESS,
  DELETE_VARIANCE_ATTACHMENT_ERROR,
  FETCH_VARIANCE_HISTORY,
  FETCH_VARIANCE_HISTORY_SUCCESS,
  FETCH_VARIANCE_HISTORY_ERROR,
  SYNC_LAB_STOCK,
  SYNC_LAB_STOCK_SUCCESS,
  SYNC_LAB_STOCK_ERROR,
  FETCH_LAST_SYNC_TIME,
  FETCH_LAST_SYNC_TIME_SUCCESS,
  FETCH_LAST_SYNC_TIME_ERROR,
};